export default "__VITE_ASSET__Di0gEKuj__"